import { useState, useEffect, useContext } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import TopNavBar from '../components/navigation/TopNavBar'
import SectionHeaderView from '../components/views/SectionHeaderView'
import RoundedButton from '../components/buttons/RoundedButton'
import RoundedButtonLink from '../components/buttons/RoundedButtonLink'
import RoundedBorderButton from '../components/buttons/RoundedBorderButton'
import BorderlessFormInput from '../components/inputs/BorderlessFormInput'
import BorderlessTextAreaInput from '../components/inputs/BorderlessTextAreaInput'
import DateTimePickerInput from '../components/inputs/DateTimePickerInput'
import EventIcon from '@mui/icons-material/Event'
import LoadingModal from '../components/modals/LoadingModal'
import * as Constants from '../utils/constants'
import { v4 as uuid } from 'uuid'
import dayjs from 'dayjs'
import { UserContext } from '../App'
import { isExpired } from 'react-jwt'
import { ToastContainer, toast } from 'react-toastify'
import arrow from '../assets/arrow.png'
import cross from '../assets/cross.png'
import strings from '../res/strings'
import 'react-toastify/dist/ReactToastify.css'

const NewScheduleFacilities = () => {
    const { state } = useLocation()
    let schedule = null

    if (state) {
        ( { schedule } = state)
    }

    const [maxDate, setMaxDate] = useState(null)
    const [excludedDates, setExcludedDates] = useState([])

    const [startDateTime, setStartDateTime] = useState(null)
    const [startDateTimeError, setStartDateTimeError] = useState(false)
    const [numberOfMen, setNumberOfMen] = useState('')
    const [description, setDescription] = useState('')
    const [services, setServices] = useState([])

    const [editIndex, setEditIndex] = useState(-1)
    const [currentService, setCurrentService] = useState()

    const [isLoading, setIsLoading] = useState(true)

    const { loggedUser, setLoggedUser } = useContext(UserContext)
    const navigate = useNavigate()

    useEffect(() => {
        if(loggedUser !== null && loggedUser !== 'refresh') {
            const isTokenExpired = isExpired(loggedUser.jwtToken)

            if(isTokenExpired) {
                setLoggedUser(null)
                navigate('/')
            } else if(loggedUser.role === Constants.Roles.CLIENT) {
                navigate('/')
            } else {
                getExcludedDates()

                const today = new Date()
                const oneYearLater = new Date()
                oneYearLater.setFullYear(today.getFullYear() + 1)

                setMaxDate(dayjs(oneYearLater))
            }
        } else if (loggedUser === null) {
            navigate('/')
        }
    }, [loggedUser])

    // Handle get non possible days
    const getExcludedDates = () => {
        fetch(`/api/Schedule/${schedule && schedule.harborId}/NonPossibleDays`, {
            method:'GET',
            headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json; charset=UTF-8',
            'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                setIsLoading(false)
                
                if (response.status === 200) {
                    const jsonRes = await response.json()

                    let noPossibleDates = []

                    jsonRes.map((date) => {
                        noPossibleDates.push(new Date(date))
                    })
                  
                    setExcludedDates(noPossibleDates)
                } else {
                    showErrorToast(strings.getExcludedDatesError)
                    setExcludedDates([])
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)

                setExcludedDates([])
            }, 1000)   
        })
    }

    // Handle changes in start date input
    const onChangeStartDateTime = (selectedDateTime, context) => {
        if(context.validationError !== 'invalidDate' || context.validationError !== 'disablePast') {
            setStartDateTime(selectedDateTime)
        }
    }

    // Handle when date is selected in date input for start date
    const onAcceptStartDateTime = (selectedDateTime) => {
        setStartDateTime(selectedDateTime)
    }

    // Handle errors in date input for stay start date
    const onErrorStartDateTime = (error) => {
        if(error) {
            setStartDateTimeError(true)
        } else {
            setStartDateTimeError(false)
        }
    }

    // Handle changes in password input text
    const onChangeNumberOfMen = (numberOfMenText) => {
        setNumberOfMen(numberOfMenText.target.value)
    }

    // Handle changes in password input text
    const onChangeDescription = (descriptionText) => {
        setDescription(descriptionText.target.value)
    }

    // Handles date formatting
    const formatDate = (timeStamp) => {
        const day = timeStamp.getDate()
        const month = timeStamp.getMonth() + 1
        const year = timeStamp.getFullYear()
        const hours = timeStamp.getHours()
        const minutes = timeStamp.getMinutes()
        return `${day < 10 ? '0' + day : day}/${month < 10 ? '0' + month : month}/${year} ${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`
    }

    // Handle add service to table
    const addService = () => {
        if(startDateTime && numberOfMen.trim().length !== 0 && description.trim().length !== 0) {

            const newService = {
                id: uuid(),
                StartDate: new Date(startDateTime),
                NumberMen: parseInt(numberOfMen),
                Description: description
            }

            const newExcludedDate = {
                id: newService.id,
                date: new Date(startDateTime)
            }

            setServices([...services, newService])
            setExcludedDates([...excludedDates, newExcludedDate])
            resetVariables()
        }
    }

    // Handle remove service from table
    const removeService = (selectedService) => {
        setServices(services.filter((service) => service.id !== selectedService.id))
        setExcludedDates(excludedDates.filter((date) => date.id !== selectedService.id))
    }

    // Handle double click on description
    const handleDoubleClick = (service) => {
        setEditIndex(service.id)
        setCurrentService(service)
    }

    // Handle changes in edited description input text
    const onChangeCurrentServiceDescription = (descriptionText) => {
        setCurrentService({ ...currentService, description: descriptionText.target.value })
    }
    
    // Save edited item into state
    const handleSaveItem = () => {
        setEditIndex(-1)
        const updatedServices = updateDescriptionById(services, currentService.id, currentService.Description)
        setServices(updatedServices)
    }

    // Update edited description into the right object
    const updateDescriptionById = (array, id, newDescription) => {
        const index = array.findIndex(item => item.id === id)

        if (index !== -1) {
            const updatedArray = [...array]
            updatedArray[index] = { ...updatedArray[index], description: newDescription }
            return updatedArray
        } else {
            return array
        }
    }

    // Handle on key down after editing description
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
          handleSaveItem()
        }

        if(event.key === 'Escape') {
            setEditIndex(-1)
        }
    }

    // Create new schedule
    const newSchedule = () => {
        setIsLoading(true)

        let facilities = []

        services.map((service) => {
            const newFacility = {
                StartDate: service.StartDate.toISOString(),
                NumberMen: service.NumberMen,
                Description: service.Description
            }

            facilities.push(newFacility)
        })

        const data = {
            UserId: loggedUser.role === Constants.Roles.CLIENT ? loggedUser.userId : schedule.userId,
            BoatId: schedule.boatId,
            HarborId: schedule.harborId,
            ScheduleTypeId: schedule.scheduleTypeId,
            StartDate: null,
            EndDate: null,
            DryStartDate: null,
            SwimStartDate: null,
            LineChangeStartDate: null,
            SupplyPersonnelStartDate: null,
            SupplyPersonnelEndDate: null,
            SupplyPersonnel: null,
            RippingStartDate: null,
            RippingEndDate: null,
            RippingDescription: null,
            AccessFacilities: facilities,
            PowerStartDate: null,
            PowerEndDate: null,
            Power: null
        }

        // Create new schedule
        fetch('/api/Schedule/Create', {
            method:'POST',
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': 'Bearer ' + loggedUser.jwtToken
            }, 
            mode: 'cors',
            body: JSON.stringify(data)
        }).then(async response => {
            setTimeout(() => {
                setIsLoading(false)

                if (response.status === 200) {
                    navigate('/backoffice-schedules')
                } else {
                    showErrorToast(strings.createScheduleError)
                }
            }, 1000)

        }).catch((error) => {
            setTimeout(() => {
                setIsLoading(false)
                showErrorToast(error)
            }, 1000)
        })
    }

    // Resets local state variables
    const resetVariables = () => {
        setStartDateTime(null)
        setStartDateTimeError(false)
        setNumberOfMen('')
        setDescription('')
    }

    // Handle show error toast
    const showErrorToast = (error) => {
        toast.error(error, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: 'colored'
        })
    }

    return (
        <>
            <TopNavBar />

            <div onClick={() => setEditIndex(-1)} className='flex flex-col px-[12.5rem] min-h-screen mb-6'>
                { isLoading ?
                    <LoadingModal />
                :   <>
                        <div className='flex flex-row items-center mt-16 mb-10 space-x-2'>
                            <button onClick={() => navigate(-1)}>
                                <img className='h-5 w-5' src={arrow} alt='Voltar atrás'/>
                            </button>
                            <p className='font-montserrat font-semibold text-accent'>{strings.newSchedule} / {strings.accessToFacilities}</p>
                        </div>
                        
                        <SectionHeaderView 
                            text={strings.accessToFacilities}
                            margin={24}
                        />

                        <p className='font-montserrat text-sm px-4'>{strings.dateInfo}</p>

                        <div className='flex flex-row px-4 py-2 bg-anti-flash-white rounded mt-8'>
                            <p className='font-montserrat font-semibold text-navy w-1/4'>{strings.dateStartTime}</p>
                            <p className='font-montserrat font-semibold text-navy w-1/4'>{strings.nrOfMen}</p>
                            <p className='font-montserrat font-semibold text-navy w-3/4'>{strings.workDescription}</p>
                        </div>

                        { services.map((service) => (
                            <div key={service.id}>
                                <div className='flex flex-row p-4'>
                                    <div className='flex flex-row items-start w-1/4'>
                                        <EventIcon style={{ color: '#383838' }} />
                                        <p className='font-montserrat ms-2 text-neutral6'>{formatDate(service.StartDate)}</p>
                                    </div>

                                    <div className='w-1/4'>
                                        <p className='font-montserrat text-neutral6'>{service.NumberMen}</p>
                                    </div>

                                    <div onDoubleClick={() => handleDoubleClick(service)} className='flex flex-row justify-between w-3/4 select-none'>
                                        {editIndex === service.id ? (
                                            <div className='flex flex-row w-11/12 space-x-6'>
                                                <input
                                                    autoFocus
                                                    className='flex-1 focus:outline-none'
                                                    type='text'
                                                    value={currentService && currentService.Description}
                                                    onChange={onChangeCurrentServiceDescription}
                                                    onKeyDown={handleKeyDown}
                                                />
                                            </div>
                                        ) : (
                                            <p className='font-montserrat text-neutral6'>{service.Description}</p>
                                        )}

                                        <button className='ms-[1.375rem] self-start' onClick={() => removeService(service)}>
                                            <img className='h-[1.438rem] w-[1.438rem]' src={cross} alt='Fechar'/>
                                        </button>
                                    </div>

                                </div>
                                <div className='h-px bg-neutral3'/>
                            </div>
                        )) }
                        
                        <div className='flex flex-row p-4'>
                            <div className='flex flex-row items-start w-1/4'>
                                <div className='w-60'>
                                    <DateTimePickerInput 
                                        value={startDateTime}
                                        onChange={onChangeStartDateTime}
                                        onAccept={onAcceptStartDateTime}
                                        onError={onErrorStartDateTime}
                                        disabledDates={excludedDates}
                                        maxDate={maxDate}
                                    />
                                    { startDateTimeError ? 
                                        <p className='font-montserrat text-xs font-medium text-negative mt-1.5 h-2'>{strings.invalidDate}</p>
                                    : null }
                                </div>
                            
                            </div>

                            <div className='w-1/4'>
                                <BorderlessFormInput 
                                    id='numberOfMen' 
                                    type='text'
                                    value={numberOfMen}
                                    placeholder={strings.insert}
                                    onChange={onChangeNumberOfMen}
                                />
                            </div>

                            <div className='flex flex-row space-x-6 w-3/4'>
                                <BorderlessTextAreaInput
                                    id='description' 
                                    type='text'
                                    value={description}
                                    placeholder={strings.insert}
                                    onChange={onChangeDescription}
                                />

                                <div className='flex w-32'>
                                    <RoundedButton 
                                        onClick={() => addService()}
                                        text={strings.add}
                                        height={40}
                                        bgColor='#26AB93'
                                        disabled={!startDateTime || numberOfMen.trim().length === 0 || description.trim().length === 0 ? true : false}
                                    />
                                </div>
                                
                            </div>

                        </div>

                        <div className='h-px bg-neutral3'/>

                        <p className='font-montserrat text-sm font-semibold mt-6'>{strings.duration}: <span className='font-normal'>{services.length} {services.length === 1 ? strings.day : strings.days}</span></p>
                        
                        <div className='mt-10 mb-[4.625rem] flex flex-row items-center justify-between'>

                            <div className='flex w-60'>
                                <RoundedButtonLink 
                                    path='/backoffice-schedules'
                                    text={strings.cancel}
                                    height={48}
                                    bgColor='#E85F5C'
                                    flex={true}
                                />
                            </div>
                                
                            <div className='flex flex-row w-[30rem] space-x-6'>
                                <RoundedBorderButton 
                                    text={strings.back}
                                    onClick={() => navigate(-1)}
                                    height={48}
                                    fontWeight='700'
                                />
                            
                                <RoundedButton 
                                    onClick={newSchedule}
                                    text={strings.schedule}
                                    height={48}
                                    bgColor='#007EB4'
                                    disabled={services.length === 0 ? true : false}
                                />
                            </div>
                            
                        </div>
                    </>
                }

            </div>

            <ToastContainer />
        </>
    )
}

export default NewScheduleFacilities